<template>
  <div class="maindiv snotice-wrap">
    <div class="ht200 sindex-bg"></div>
    <div class="bar-menu2 wd1200 tcenter fs0 pb40 pt30">
      <left></left>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Left from "../../components/enroll/Left";
export default {
  name: "goArticle",
  components:{
    Left
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/enroll/goArticle.vue